import React, { useState } from 'react'
import { Select, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import { MEMO_TEMPLATES, appendMemoTemplate } from '../../../../data/memoTemplates'

/**
 * レポートメモ欄向け定型文挿入（No.8）
 * 選択するとメモ末尾へ追記。サンプル文言でUI確認可能。
 */
function MemoTemplateInsert({ value, onInsert }) {
  const { t } = useTranslation()
  const [selected, setSelected] = useState(undefined)

  const handleChange = (templateId) => {
    const template = MEMO_TEMPLATES.find((item) => item.id === templateId)
    if (!template) return
    onInsert(appendMemoTemplate(value, template.body))
    setSelected(undefined)
  }

  return (
    <div className="memo-template-insert mb10">
      <Space wrap className="flex_item_cs" style={{ width: '100%' }}>
        <span className="fs-14 text-gray">{t('Reports.Insert_Template')}</span>
        <Select
          allowClear
          value={selected}
          placeholder={t('Reports.Select_Template')}
          style={{ minWidth: 280, maxWidth: '100%' }}
          options={MEMO_TEMPLATES.map((item) => ({
            value: item.id,
            label: item.label,
          }))}
          onChange={handleChange}
        />
      </Space>
    </div>
  )
}

export default MemoTemplateInsert
